// hooks/useDashboardSocket.ts
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { WSInstance } from './web-socket-service';

export const useSocket = (onMetrics: (data: any) => void) => {
    const token = useSelector((state: any) => state.app.session?.token);
    const machineId = useSelector((state: any) => state.heater.metricsData.machine_id);
    useEffect(() => {
        if (!token || !machineId) return;

        WSInstance.connect(token);
        console.warn(machineId, 'machineId in useSocket');
        WSInstance.on(`dashboard/${machineId}/metrics`, onMetrics);

        WSInstance.socket?.io.on('error', (error: any) => {
            console.warn('Socket error:', error);
        });
        // eslint-disable-next-line consistent-return
        return () => {
            console.warn('unmounting socket');
            WSInstance.off(`dashboard/${machineId}/metrics`, onMetrics);
        };
    }, [machineId, token, onMetrics]);
};

export const useMachineConfigSocket = (onMetrics: (data: any) => void) => {
    const token = useSelector((state: any) => state.app.session?.token);
    const userId = useSelector((state: any) => state?.user?.userId);
    useEffect(() => {
        if (!token || !userId) return;

        WSInstance.connect(token);
        console.warn(userId, 'userId in useSocket');
        WSInstance.on(`device/${userId}/config`, onMetrics);

        WSInstance.socket?.io.on('error', (error: any) => {
            console.warn('Socket error:', error);
        });
        // eslint-disable-next-line consistent-return
        return () => {
            console.warn('unmounting socket');
            WSInstance.off(`device/${userId}/config`, onMetrics);
        };
    }, [userId, token, onMetrics]);
};
